import * as React from 'react';
import { Field } from 'react-final-form';
import MathUtil from 'src/util/MathUtil';

interface IFormTextProps {
    label?: string;
    name: string;
    className?: string;
    type?: string;
}

const FormText = (props: IFormTextProps) => {
    const formTextClass = `dlc-form-text ${props.className}`;

    const textField = (
        <Field name={props.name}>
            {({ input }) => (
                <span className={`form-text ${props.className}`}>
                    {
                        props.type && props.type === 'number' && !isNaN(parseFloat(input.value)) 
                        ? parseFloat(MathUtil.cleanNumber(input.value, 7)) : input.value
                    }
                </span>
            )}
        </Field>
    );

    if (props.label) {
        return (
            <label className={formTextClass}>
                {props.label}
                {textField}
            </label>
        );
    } else {
        return textField;
    }
};

export default FormText;



// WEBPACK FOOTER //
// ./src/components/controls/forms/redesign/FormText.tsx